import { useTranslation } from 'react-i18next';
import iconFirmar from '../../assets/icon-firmar.svg';

export const CardHead = () => {
    const { t } = useTranslation();

    return (
        <div className="card-head">
            <h1 className="card-title">
                <img src={iconFirmar} className="img-fluid" alt={t('cardHead.iconAlt')} />
                {t('cardHead.title')}
            </h1>
        </div>
    );
};
